export default __webpack_public_path__ + "img/3eee43d5a55e96a9988f83d39481fe5d.png";